module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerExtraBold.4b267650.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerExtraBold.otf
// module id = 1062
// module chunks = 0